// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container for the timeline */
.timeline-container-ticket {
    width: 85%;
    margin: 3rem auto;
    text-align: center;
    padding: 2rem;
    background-color: var(--clr-background);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
}
  
/* Title of the timeline */
.timeline-title-ticket {
    font-size: 2.5rem;
    color: var(--clr-grey-1);
    margin-bottom: 3rem;
    text-transform: uppercase;
    letter-spacing: var(--letterSpacing);
    transition: var(--transition);
    position: relative;
    /* display: inline-block; */
    padding-bottom: 0.5rem;
}
  
/* Adding a hover effect to the title */
.timeline-title-ticket:hover {
    color: var(--clr-primary-5);
    text-shadow: 2px 2px 5px var(--clr-primary-3);
}
  
/* .timeline-title-ticket::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 3px;
    background-color: var(--clr-primary-5);
    transition: width 0.3s ease;
    width: 0;
}
  
.timeline-title-ticket:hover::after {
    width: 100%;
} */
  
/* Wrapper for the ticket steps */
.timeline-wrapper-ticket {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}
  
/* Each step of the timeline with ticket-style */
.timeline-step-ticket {
    background-color: var(--clr-white);
    padding: 1.5rem;
    /* width: 180px; */
    text-align: center;
    border-radius: var(--radius);
    position: relative;
    /* border: 2px solid var(--grey-200); */
    box-shadow: var(--shadow-1);
    margin-right: 1.5rem;
    min-height: 280px;
    transition: transform var(--transition), box-shadow var(--transition);
}
  
.timeline-step-ticket:hover {
    transform: scale(1.05);
    box-shadow: var(--shadow-3);
}
  
/* Ticket-style step section */
.timeline-step-number-ticket {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 0.8rem 1rem;
    border-radius: var(--radius) var(--radius) 0 0;
    font-size: 1.25rem;
    font-weight: bold;
}
  
.timeline-step-ticket:hover .timeline-step-number-ticket {
    background-color: var(--clr-primary-3);
}
  
/* Icon section */
.timeline-icon-ticket {
    font-size: 2.5rem;
    color: var(--clr-primary-5);
    margin: 1rem 0;
}
  
.timeline-step-ticket:hover .timeline-icon-ticket {
    transform: rotate(15deg);
}
  
/* Description for each step */
.timeline-description-ticket {
    font-size: 1rem;
    color: var(--clr-grey-5);
    margin-bottom: 1rem;
    text-align: start; 
    line-height: 1.5; 
    white-space: normal; 
    word-wrap: break-word; 
}

  
/* Highlighted action text */
.timeline-action-ticket {
    font-size: var(--small-text);
    color: var(--clr-primary-5); /* Highlighted color */
    font-weight: bold; /* Make it bold */
    letter-spacing: 0.5px; /* Slight letter-spacing for emphasis */
}
  
/* Line connecting the tickets */
.timeline-connector-ticket {
    content: '';
    position: absolute;
    top: 50%;
    right: -90px; /* Position based on card width */
    height: 4px;
    width: 80px;
    background: linear-gradient(90deg, var(--clr-primary-5), var(--clr-primary-3));
    z-index: -1;
}
  
/* Remove connecting line after the last step */
.timeline-step-ticket:last-child .timeline-connector-ticket {
    display: none;
}
  
/* Responsive adjustments */
@media (max-width: 768px) {
    .timeline-wrapper-ticket {
        flex-direction: column;
    }
  
    .timeline-step-ticket {
        width: 100%;
        margin-bottom: 2rem;
        max-width: 350px;
    }
  
    .timeline-connector-ticket {
        display: none; /* Hide the connecting line in mobile view */
    }
  
    /* Hide the connector for the last step in mobile view */
    .timeline-step-ticket:last-child .timeline-connector-ticket {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/home/Timeline/TimelineComponent.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uCAAuC;IACvC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA,0BAA0B;AAC1B;IACI,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;IACpC,6BAA6B;IAC7B,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA,uCAAuC;AACvC;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;;;;;;;;;;;;;;GAcG;;AAEH,iCAAiC;AACjC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,gDAAgD;AAChD;IACI,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,uCAAuC;IACvC,2BAA2B;IAC3B,oBAAoB;IACpB,iBAAiB;IACjB,qEAAqE;AACzE;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,8BAA8B;AAC9B;IACI,sCAAsC;IACtC,uBAAuB;IACvB,oBAAoB;IACpB,8CAA8C;IAC9C,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;;AAGA,4BAA4B;AAC5B;IACI,4BAA4B;IAC5B,2BAA2B,EAAE,sBAAsB;IACnD,iBAAiB,EAAE,iBAAiB;IACpC,qBAAqB,EAAE,uCAAuC;AAClE;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY,EAAE,iCAAiC;IAC/C,WAAW;IACX,WAAW;IACX,8EAA8E;IAC9E,WAAW;AACf;;AAEA,+CAA+C;AAC/C;IACI,aAAa;AACjB;;AAEA,2BAA2B;AAC3B;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa,EAAE,4CAA4C;IAC/D;;IAEA,wDAAwD;IACxD;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* Main container for the timeline */\n.timeline-container-ticket {\n    width: 85%;\n    margin: 3rem auto;\n    text-align: center;\n    padding: 2rem;\n    background-color: var(--clr-background);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n}\n  \n/* Title of the timeline */\n.timeline-title-ticket {\n    font-size: 2.5rem;\n    color: var(--clr-grey-1);\n    margin-bottom: 3rem;\n    text-transform: uppercase;\n    letter-spacing: var(--letterSpacing);\n    transition: var(--transition);\n    position: relative;\n    /* display: inline-block; */\n    padding-bottom: 0.5rem;\n}\n  \n/* Adding a hover effect to the title */\n.timeline-title-ticket:hover {\n    color: var(--clr-primary-5);\n    text-shadow: 2px 2px 5px var(--clr-primary-3);\n}\n  \n/* .timeline-title-ticket::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    height: 3px;\n    background-color: var(--clr-primary-5);\n    transition: width 0.3s ease;\n    width: 0;\n}\n  \n.timeline-title-ticket:hover::after {\n    width: 100%;\n} */\n  \n/* Wrapper for the ticket steps */\n.timeline-wrapper-ticket {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: relative;\n}\n  \n/* Each step of the timeline with ticket-style */\n.timeline-step-ticket {\n    background-color: var(--clr-white);\n    padding: 1.5rem;\n    /* width: 180px; */\n    text-align: center;\n    border-radius: var(--radius);\n    position: relative;\n    /* border: 2px solid var(--grey-200); */\n    box-shadow: var(--shadow-1);\n    margin-right: 1.5rem;\n    min-height: 280px;\n    transition: transform var(--transition), box-shadow var(--transition);\n}\n  \n.timeline-step-ticket:hover {\n    transform: scale(1.05);\n    box-shadow: var(--shadow-3);\n}\n  \n/* Ticket-style step section */\n.timeline-step-number-ticket {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 0.8rem 1rem;\n    border-radius: var(--radius) var(--radius) 0 0;\n    font-size: 1.25rem;\n    font-weight: bold;\n}\n  \n.timeline-step-ticket:hover .timeline-step-number-ticket {\n    background-color: var(--clr-primary-3);\n}\n  \n/* Icon section */\n.timeline-icon-ticket {\n    font-size: 2.5rem;\n    color: var(--clr-primary-5);\n    margin: 1rem 0;\n}\n  \n.timeline-step-ticket:hover .timeline-icon-ticket {\n    transform: rotate(15deg);\n}\n  \n/* Description for each step */\n.timeline-description-ticket {\n    font-size: 1rem;\n    color: var(--clr-grey-5);\n    margin-bottom: 1rem;\n    text-align: start; \n    line-height: 1.5; \n    white-space: normal; \n    word-wrap: break-word; \n}\n\n  \n/* Highlighted action text */\n.timeline-action-ticket {\n    font-size: var(--small-text);\n    color: var(--clr-primary-5); /* Highlighted color */\n    font-weight: bold; /* Make it bold */\n    letter-spacing: 0.5px; /* Slight letter-spacing for emphasis */\n}\n  \n/* Line connecting the tickets */\n.timeline-connector-ticket {\n    content: '';\n    position: absolute;\n    top: 50%;\n    right: -90px; /* Position based on card width */\n    height: 4px;\n    width: 80px;\n    background: linear-gradient(90deg, var(--clr-primary-5), var(--clr-primary-3));\n    z-index: -1;\n}\n  \n/* Remove connecting line after the last step */\n.timeline-step-ticket:last-child .timeline-connector-ticket {\n    display: none;\n}\n  \n/* Responsive adjustments */\n@media (max-width: 768px) {\n    .timeline-wrapper-ticket {\n        flex-direction: column;\n    }\n  \n    .timeline-step-ticket {\n        width: 100%;\n        margin-bottom: 2rem;\n        max-width: 350px;\n    }\n  \n    .timeline-connector-ticket {\n        display: none; /* Hide the connecting line in mobile view */\n    }\n  \n    /* Hide the connector for the last step in mobile view */\n    .timeline-step-ticket:last-child .timeline-connector-ticket {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
